import React from "react";


const Get_In_Touch = () => {
    return(
        <h1>Get_In_Touch</h1>
    )
}

export default Get_In_Touch